const production = true

// const IP = production ? "cahbookbackend-production.up.railway.app" : "localhost:5000"

///// const IP = production ? "45.194.2.12:5000" : "localhost:5000"

const IP = production ? "api-headsupbook.headsupcorporation.com" : "localhost:5000"





const Protocol = production ? "https://" : "http://"

export const auth = 'api/auth/'


const BaseUrl = `${Protocol}${IP}/`


//Auths

export const login = BaseUrl + auth + 'login'
export const register = BaseUrl + auth + 'register'
export const forgotPassword = BaseUrl + auth + 'forgotPassword'
export const resetPassword = BaseUrl + auth + 'resetPassword'
export const searchUser = BaseUrl + auth + 'searchUser'
export const updateUser = BaseUrl + auth + 'updateUser'
export const deleteUser = BaseUrl + auth + "deleteUser"


//Expense

export const addExpense = BaseUrl + 'addExpense'
export const searchExpense = BaseUrl + 'searchExpense'
export const updateExpense = BaseUrl + 'updateExpense'
export const deleteExpense = BaseUrl + 'deleteExpense'

//CashbookRecords
export const addCashRecord = BaseUrl + "addCashRecord"
export const searchCashRecord = BaseUrl + "searchCashRecords"
export const deleteCashRecord = BaseUrl + 'deleteCashRecord'
export const updateCashrecord = BaseUrl + 'updateCashrecord'
export const getCashRecordStats = BaseUrl + 'statsCashRecord'
export const dailyStatsCashRecord = BaseUrl + 'dailyStatsCashRecord'



//Uplaod

export const upload = BaseUrl + 'upload'


//RolesAndPermission

export const addRole = BaseUrl + 'addRole'
export const updateRole = BaseUrl + 'updateRole'
export const searchRole = BaseUrl + 'searchRole'
export const deleteRole = BaseUrl + 'deleteRole'


//BussinessAccount
export const addAccount = BaseUrl + 'addAccount'
export const updateAccount = BaseUrl + 'updateAccount'
export const searchAccount = BaseUrl + "searchAccount"
export const deleteAccount = BaseUrl + "deleteAccount"

//Books
export const addBook = BaseUrl + 'addBook'
export const updateBook = BaseUrl + 'updateBook'
export const searchBook = BaseUrl + "searchBook"
export const deleteBook = BaseUrl + "deleteBook"








